<template>
  <div>
    <div v-if="loadingTranslations" class="mt-3">
      <div class="text-center">
        <v-progress-circular
          indeterminate
          size="100"
          width="8"
        ></v-progress-circular>
      </div>
      <v-row justify="center" class="mt-8">
        <v-col cols="2" class="text-center">
          <p class="basic--text">
            Searching for words to translate... Please wait...
          </p>
        </v-col>
      </v-row>
    </div>

    <div v-if="translationsFailed">
      <v-row class="pb-2" justify="center">
        <v-img :src="require(`@/assets/${responseImg}`)" max-width="300">
        </v-img>
      </v-row>
      <v-row class="pb-2 text-center" justify="center">
        <h3 class="basic--text">{{ responseMessage }}</h3>
      </v-row>
      <v-row>
        <v-col cols="1"
          ><v-btn outlined color="error" @click="getProductsForUpload">
            <v-icon left>mdi-arrow-left-bold-outline</v-icon>
            Back
          </v-btn></v-col
        >
        <v-spacer></v-spacer>
      </v-row>
    </div>

    <div v-if="showWordsTable">
      <v-row justify="center">
        <v-col>
          <h2 class="basic--text text-center">
            <v-icon color="secondary"> mdi-translate</v-icon> Translations
          </h2>
          <p class="basic--text text-center">
            Please translate the following words
          </p>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="8">
          <v-form ref="form">
            <v-data-table
              dense
              class="translation_table"
              :items="wordsMap"
              :headers="headers"
              :footer-props="{
                'items-per-page-options': [30, 50, 100, 150, 200],
              }"
            >
              <template v-slot:[`item.value`]="{ item }">
                <v-text-field
                  outlined
                  dense
                  v-model="item.value"
                  type="text"
                  :rules="[rules.required]"
                  hide-details="auto"
                  style="width: 100%"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-form>
        </v-col>
      </v-row>

      <!-- Russian translation -->
      <v-row justify="center">
        <v-col cols="8">
          <v-form ref="form">
            <v-data-table
              dense
              class="translation_table"
              :items="wordsMapRu"
              :headers="HeadersRU"
              :footer-props="{
                'items-per-page-options': [30, 50, 100, 150, 200],
              }"
            >
              <template v-slot:[`item.value`]="{ item }">
                <v-text-field
                  outlined
                  dense
                  v-model="item.value"
                  type="text"
                  :rules="[rules.required]"
                  hide-details="auto"
                  style="width: 100%"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-form>
        </v-col>
      </v-row>

      <!-- Estonian translation -->
      <v-row justify="center">
        <v-col cols="8">
          <v-form ref="form">
            <v-data-table
              class="translation_table"
              dense
              :items="wordsMapEt"
              :headers="HeadersEt"
              :footer-props="{
                'items-per-page-options': [30, 50, 100, 150, 200],
              }"
            >
              <template v-slot:[`item.value`]="{ item }">
                <v-text-field
                  outlined
                  dense
                  v-model="item.value"
                  type="text"
                  :rules="[rules.required]"
                  hide-details="auto"
                  style="width: 100%"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-form>
        </v-col>
      </v-row>
      <!-- Finnish translation -->
      <v-row justify="center">
        <v-col cols="8">
          <v-form ref="form">
            <v-data-table
              class="translation_table"
              dense
              :items="wordsMapFi"
              :headers="HeadersFi"
              :footer-props="{
                'items-per-page-options': [30, 50, 100, 150, 200],
              }"
            >
              <template v-slot:[`item.value`]="{ item }">
                <v-text-field
                  outlined
                  dense
                  v-model="item.value"
                  type="text"
                  :rules="[rules.required]"
                  hide-details="auto"
                  style="width: 100%"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-form>
        </v-col>
      </v-row>

      <!-- Latvian translation -->
      <v-row justify="center">
        <v-col cols="8">
          <v-form ref="form">
            <v-data-table
              dense
              class="translation_table"
              :items="wordsMapLv"
              :headers="HeadersLv"
              :footer-props="{
                'items-per-page-options': [30, 50, 100, 150, 200],
              }"
            >
              <template v-slot:[`item.value`]="{ item }">
                <v-text-field
                  outlined
                  dense
                  v-model="item.value"
                  type="text"
                  :rules="[rules.required]"
                  hide-details="auto"
                  style="width: 100%"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="1"></v-col>
        <v-spacer></v-spacer>
        <v-col cols="3"
          ><v-btn
            outlined
            color="success"
            :disabled="loadingTranslations"
            @click="saveTranslations"
            >Export to pigu.lt
            <v-icon right>mdi-arrow-right-bold-outline</v-icon></v-btn
          ></v-col
        >
      </v-row>
    </div>

    <v-snackbar
      top
      v-model="snackbar"
      color="#FF3232"
      class="white--text"
      width="800"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="PiguLtExportDone" width="500px">
      <v-card>
        <v-card-title class="footer basic--text"> XML link </v-card-title>
        <v-card-text>
          <v-row justify="center" class="mt-5">
            <v-col cols="9">
              <a :href="xmlLink" target="_blank">{{ xmlLink }}</a>
            </v-col>
            <v-col cols="3">
              <v-btn outlined color="success" v-clipboard:copy="xmlLink"
                >Copy</v-btn
              >
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-5">
            <p>
              this link has only the products exported today <br />
              it will auto generate new one each day.
            </p>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer class="go_listing">
            <v-btn
              outlined
              color="success"
              @click="goToListing"
              class="go_listing_btn"
              >go to listing</v-btn
            >
            <v-btn
              outlined
              color="success"
              @click="DownloadXML"
              class="go_listing_btn"
              >Download XML file</v-btn
            >
          </v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="statusDialog" width="850px">
      <status-info
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="closeStatusDialog"
        :textColor="textColor"
        :showCheckBtn="showCheckBtn"
      ></status-info>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import StatusInfo from "../organisms/StatusInfo";

export default {
  name: "TranslateWorld",
  props: {},
  components: { StatusInfo },
  computed: {
    headers() {
      let headers = [
        {
          text: "Word(s)",
          value: "word",
          class: "footer pr-0",
          align: "right",
        },
        {
          text: "lithuanian",
          value: "value",
          class: "footer pl-6",
          align: "left",
        },
      ];
      return headers;
    },
    HeadersRU() {
      let headersRu = [
        {
          text: "Word(s)",
          value: "word",
          class: "footer pr-0",
          align: "right",
        },
        {
          text: "Russian",
          value: "value",
          class: "footer pl-6",
          align: "left",
        },
      ];
      return headersRu;
    },
    HeadersEt() {
      let HeadersEt = [
        {
          text: "Word(s)",
          value: "word",
          class: "footer pr-0",
          align: "right",
        },
        {
          text: "Estonian",
          value: "value",
          class: "footer pl-6",
          align: "left",
        },
      ];
      return HeadersEt;
    },
    HeadersFi() {
      let HeadersFi = [
        {
          text: "Word(s)",
          value: "word",
          class: "footer pr-0",
          align: "right",
        },
        {
          text: "Finnish",
          value: "value",
          class: "footer pl-6",
          align: "left",
        },
      ];
      return HeadersFi;
    },
    HeadersLv() {
      let HeadersLv = [
        {
          text: "Word(s)",
          value: "word",
          class: "footer pr-0",
          align: "right",
        },
        {
          text: "Latvian",
          value: "value",
          class: "footer pl-6",
          align: "left",
        },
      ];
      return HeadersLv;
    },
  },
  data: () => ({
    pending: false,
    filename: "",
    textColor: "",
    showCheckBtn: false,
    statusDialog: false,
    showWordsTable: false,
    loadingTranslations: true,
    translationsFailed: false,
    responseImg: "",
    responseMessage: "",
    wordsMap: [],
    wordsMapRu: [],
    wordsMapEt: [],
    wordsMapFi: [],
    wordsMapLv: [],
    IsExported: false,
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    snackbar: false,
    snackbarText: "",
    PiguLtExportDone: false,
    xmlLink: null,
    loadingExportPiguLt: false,
    SKUS: [],
  }),
  async mounted() {
    await this.getProductsToTranslate();
  },
  methods: {
    closeStatusDialog() {
      this.statusDialog = false;
    },
    async DownloadXML() {
      await axios.get(this.xmlLink).then((result) => {
        var xmltext = result.data;

        var filename = "products.xml";
        var pom = document.createElement("a");
        var bb = new Blob([xmltext], { type: "text/plain" });

        pom.setAttribute("href", window.URL.createObjectURL(bb));
        pom.setAttribute("download", filename);

        pom.dataset.downloadurl = ["text/plain", pom.download, pom.href].join(
          ":"
        );
        pom.draggable = true;
        pom.classList.add("dragout");

        pom.click();
      });
    },
    async goToListing() {
      this.$router.push("/listingsupervision");
    },
    async getProductsToTranslate() {
      var languages = ["lt", "ru", "ee", "fi", "lv"];
      var skus = JSON.parse(localStorage.getItem("skus-pigult"));
      console.log("those are skus ==>", skus);
      this.SKUS = skus;

      try {
        languages.map(async (item) => {
          let body = {
            language: item,
            skus: skus,
          };
          const response = await this.$store.dispatch(
            "getProductsToTranslate",
            body
          );
          if (item == "lt") {
            this.wordsMap = await this.mapWords(response.data);
          }
          if (item == "ru") {
            this.wordsMapRu = await this.mapWords(response.data);
          }
          if (item == "ee") {
            this.wordsMapEt = await this.mapWords(response.data);
          }
          if (item == "ee") {
            this.wordsMapFi = await this.mapWords(response.data);
          }
          if (item == "lv") {
            this.wordsMapLv = await this.mapWords(response.data);
            this.loadingTranslations = false;
            this.showWordsTable = true;
            if (
              response.data.length < 1 &&
              this.wordsMapEt.length < 1 &&
              this.wordsMap.length < 1 &&
              this.wordsMapRu.length < 1 &&
              this.wordsMapLv.length < 1 &&
              this.wordsMapFi < 1
            ) {
              this.ExportToPiguLT();
            }
          }
        });
      } catch (error) {
        console.log(error);
        this.loadingTranslations = false;
        this.responseImg = "feeling_blue.svg";
        this.responseMessage = error.response.data
          ? error.response.data
          : "Something went wrong when trying to get products to translate...";
        this.translationsFailed = true;
      }
    },

    async mapWords(words) {
      let result = [];
      result = words.map((word) => {
        return { word, value: "" };
      });
      return result;
    },
    //check if wordsMap contains any empty strings
    validateWordsMap(wordsMap) {
      return wordsMap.find((el) => el.value == "");
    },
    saveTranslations() {
      if (this.$refs.form.validate()) {
        if (
          !this.validateWordsMap(this.wordsMap) ||
          !this.validateWordsMap(this.wordsMapRu) ||
          !this.validateWordsMap(this.wordsMapEt) ||
          !this.validateWordsMap(this.wordsMapLv) ||
          !this.validateWordsMap(this.wordsMapFi)
        ) {
          var promise = new Promise((resolve) => {
            this.pushTranslations(this.wordsMap, "lt");
            this.pushTranslations(this.wordsMapRu, "ru");
            this.pushTranslations(this.wordsMapEt, "ee");
            this.pushTranslations(this.wordsMapLv, "lv");
            this.pushTranslations(this.wordsMapFi, "fi");
            resolve();
          });
          promise.then(async () => {
            await this.ExportToPiguLT();
          });
        } else {
          this.snackbarText = "There are empty fields left in other pages!";
          this.snackbar = true;
        }
      }
    },
    async pushTranslations(wordsMap, lng) {
      let data = await this.formatData(wordsMap, lng);
      this.loadingTranslations = true;

      try {
        console.log(data);
        await this.$store.dispatch("saveTranslationsOnPlatforms", data);
      } catch (error) {
        console.log(error);
        this.loadingTranslations = false;
        this.responseImg = "feeling_blue.svg";
        this.responseMessage = error.response.data
          ? error.response.data
          : "Something went wrong when trying to save translations...";
        this.translationsFailed = true;
      }
    },
    async ExportToPiguLT() {
      console.log(this.IsExported);
      if (this.IsExported == true) {
        this.loadingTranslations = false;
        this.PiguLtExportDone = true;
        return;
      }
      this.loadingExportPiguLt = true;
      this.$store
        .dispatch("exportToPiguLt", this.SKUS)
        .then((result) => {
          this.loadingExportPiguLt = false;
          this.xmlLink = result.data.link;
          this.PiguLtExportDone = true;
          this.loadingTranslations = false;
          this.IsExported = true;
        })
        .catch((err) => {
          console.log(err.response.data);
          this.statusDialog = true;
          this.responseMessage = err.response.data;
          this.filename = "feeling_blue.svg";
        });
    },
    async copyToClipboard() {
      navigator.clipboard
        .writeText(this.xmlLink)
        .then(() => {
          console.log("Copied !");
        })
        .catch((err) => {
          console.log("Error in copying text: ", err);
        });
    },
    //format data to send to backend
    async formatData(wordsMap, lng) {
      let result = {
        language: lng,
        translations: {},
      };
      for (let object of wordsMap) {
        result.translations[object.word] = object.value.trim();
      }
      return result;
    },
    getProductsForUpload() {
      this.$emit("getProductsForUpload");
    },
  },
};
</script>

<style>
.translation_table th {
  width: 50% !important;
}
.go_listing {
  display: flex;
  gap: 15px;
  justify-content: flex-start;
}
.go_listing_btn {
  display: flex;
  justify-content: flex-start;
}
</style>
